var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.67977 12.1259C1.73472 14.6536 1.7622 15.9175 2.70493 16.8535C3.64765 17.7895 4.95969 17.8219 7.58377 17.8868C9.19925 17.9267 10.8004 17.9267 12.4159 17.8868C15.04 17.8219 16.352 17.7895 17.2948 16.8535C18.2375 15.9175 18.2649 14.6536 18.3199 12.1259C18.3468 10.8875 18.3327 9.66121 18.2777 8.41012C18.2435 7.63307 18.2264 7.24455 18.0293 6.89991C17.8323 6.55527 17.4926 6.33283 16.8132 5.88796L13.6792 3.83576C11.895 2.66751 11.003 2.08337 9.99983 2.08337C8.99667 2.08337 8.10464 2.6675 6.32053 3.83576L3.18648 5.88796C2.50708 6.33283 2.16738 6.55527 1.97033 6.89991C1.77327 7.24455 1.75617 7.63308 1.72197 8.41012C1.66691 9.66121 1.65284 10.8875 1.67977 12.1259Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 7.91663L5.22098 10.4913C5.6128 10.7751 5.9714 11.0349 6.30317 11.2705C7.19992 11.9075 7.84701 12.0833 8.94667 12.0833H11.053C12.1527 12.0833 12.7998 11.9075 13.6965 11.2705C14.0283 11.0349 14.3868 10.7751 14.7787 10.4913L18.3332 7.91663",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOpen);
export default __webpack_public_path__ + "static/media/mail-open.17b2f828b2827abbc2c9d0c4461d15a5.svg";
export { ForwardRef as ReactComponent };